import {UpmEntityType, type TreeNode} from '@hconnect/common/types'
import {useCallback} from 'react'
import {NodeApi} from 'react-arborist'

import {
  isAssetEnabledForPlanning,
  isDepartmentOrEquipmentNode,
  isStorageEnabledForPlanning
} from '../../helpers'

import {PlantStructureFilterOptions} from '@settings/modules/common/enums'

export const useHandleTreeFiltering = (
  selectedFilterOption: PlantStructureFilterOptions,
  filterText: string,
  showEnglishTranslation: boolean
) => {
  const textFilter = filterText.trim().length > 0 ? filterText : undefined
  const quickFilter =
    selectedFilterOption === PlantStructureFilterOptions.PlannerStorages ||
    selectedFilterOption === PlantStructureFilterOptions.PlannerAssets
      ? selectedFilterOption
      : undefined

  const searchTerm = textFilter || quickFilter

  const handleTreeFiltering = useCallback(
    (node: NodeApi<TreeNode>) => {
      const nodeName = node.data.text ?? ''
      const englishNodeName =
        showEnglishTranslation && node.data.itemType === UpmEntityType.Department
          ? node.data.displayValueEnglish ?? ''
          : ''
      const nodeTypeName = node.data.type?.name ?? ''

      const filters = {
        textFilter: textFilter
          ? nodeName.toLowerCase().includes(textFilter.toLowerCase()) ||
            englishNodeName.toLowerCase().includes(textFilter.toLowerCase()) ||
            nodeTypeName.toLowerCase().includes(textFilter.toLowerCase())
          : true,
        plannerStoragesFilter:
          quickFilter === PlantStructureFilterOptions.PlannerStorages
            ? isDepartmentOrEquipmentNode(node.data) &&
              isStorageEnabledForPlanning(node.data.enabledForPlanningItem)
            : true,
        plannerAssetsFilter:
          quickFilter === PlantStructureFilterOptions.PlannerAssets
            ? isDepartmentOrEquipmentNode(node.data) &&
              isAssetEnabledForPlanning(node.data.enabledForPlanningItem)
            : true
      }

      return (
        Object.values(filters).every((shouldDisplayNode) => shouldDisplayNode === true) ||
        node.level === 0
      )
    },
    [quickFilter, showEnglishTranslation, textFilter]
  )

  return {searchTerm, handleTreeFiltering}
}
